module.exports = __webpack_public_path__ + "assets/0c1c7e510ac36589066365dbc2a3aef4.png";